import Build from '@mui/icons-material/Build';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function BuildIcon(props: FixMe) {
  return <Build {...props} />;
}

export default BuildIcon;
